export default __webpack_public_path__ + "static/media/vue.8ea27b3e.svg";